import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { LoggedInGuard } from './guards/loggedin.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LayoutComponent } from './modules/layout/layout.component';
import { AdminGuard } from './guards/admin.guard';
import { SalesUserGuard } from './guards/sales-user.guard';
import { CastingGuard } from './guards/casting.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/company/list',
    pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'company',
        loadChildren: () => import('./modules/company/company.module').then(m => m.CompanyModule),
        canActivate: [SalesUserGuard]
      },
      {
        path: 'kpi-statistics',
        loadChildren: () => import('./modules/kpi-statistics/kpi-statistic.module').then(m => m.KpiStatisticsModule)
      },
      {
        path: 'enterprise',
        loadChildren: () => import('./modules/enterprise/enterprise.module').then(m => m.EnterpriseModule),
        canActivate: [CastingGuard]
      },
      {
      path: 'sales-users',
        loadChildren: () => import('./modules/sales-users/sales-users.module').then(m => m.SalesUsersModule),
        canActivate: [AdminGuard]
      }
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/two-factor-auth/two-factor-auth.module').then(m => m.TwoFactorAuthModule),
    canActivate: [LoggedInGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: 'page-not-found',
    loadComponent: () => import('./page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    loadComponent: () => import('./page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
